export type visible = "visible";
export type hidden = "hidden";
export type clip  = "clip";
export type scroll = "scroll";

//  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
//    $1 |

export type CSSOverflowType = 
  visible |
  hidden |
  clip |
  scroll
;

export class CSSOverflow
{
  //  export\s*type\s*((?:\w|_)+)\s*=\s*"(.+?)";
  //  static readonly $1:$1 = "$2";

  static readonly visible:visible = "visible";
  static readonly hidden:hidden = "hidden";
  static readonly clip:clip = "clip";
  static readonly scroll:scroll = "scroll";
  
}